module.exports = __webpack_public_path__ + "img/mypost-active.5883c80a.svg";